import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import CaskAndAgingService from "../services/caskAndAgingService";

// Add CaskAndAging Start
const defaultCaskAndAgingState = {
  addCaskAndAgingLoading: false,
  addCaskAndAgingData: null,
  addCaskAndAgingError: null,
};

const addCaskAndAgingData = createAsyncThunk(
  "caskandaging/add",
  async (payload) => {
    return await CaskAndAgingService.createCaskAndAging(payload);
  },
);

const addCaskAndAgingReducer = createSlice({
  name: "addCaskAndAgingData",
  initialState: defaultCaskAndAgingState,
  extraReducers: (builder) => {
    builder.addCase(addCaskAndAgingData.pending, (state) => {
      state.addCaskAndAgingLoading = true;
    });
    builder.addCase(addCaskAndAgingData.fulfilled, (state, action) => {
      state.addCaskAndAgingLoading = false;
      state.addCaskAndAgingData = action.payload;
      state.addCaskAndAgingError = "";
    });
    builder.addCase(addCaskAndAgingData.rejected, (state, action) => {
      state.addCaskAndAgingLoading = false;
      state.addCaskAndAgingData = null;
      state.addCaskAndAgingError = action.error.message;
    });
  },
});

export const AddCaskAndAgingReducer = addCaskAndAgingReducer.reducer;
export const AddCaskAndAgingData = addCaskAndAgingData;
// Add CaskAndAging End

// Update CaskAndAging Start
const updateCaskAndAgingState = {
  updateCaskAndAgingLoading: false,
  updateCaskAndAgingData: null,
  updateCaskAndAgingError: null,
};

const updateCaskAndAging = createAsyncThunk(
  "caskandaging/update",
  async (payload) => {
    return await CaskAndAgingService.updateCaskAndAging(payload);
  },
);

const updateCaskAndAgingReducer = createSlice({
  name: "updateCaskAndAgingReducer",
  initialState: updateCaskAndAgingState,
  extraReducers: (builder) => {
    builder.addCase(updateCaskAndAging.pending, (state) => {
      state.updateCaskAndAgingLoading = true;
    });
    builder.addCase(updateCaskAndAging.fulfilled, (state, action) => {
      state.updateCaskAndAgingLoading = false;
      state.updateCaskAndAgingData = action.payload;
      state.updateCaskAndAgingError = "";
    });
    builder.addCase(updateCaskAndAging.rejected, (state, action) => {
      state.updateCaskAndAgingLoading = false;
      state.updateCaskAndAgingData = null;
      state.updateCaskAndAgingError = action.error.message;
    });
  },
});

export const UpdateCaskAndAgingReducer = updateCaskAndAgingReducer.reducer;
export const UpdateCaskAndAging = updateCaskAndAging;
//Update CaskAndAging End

// Get CaskAndAging Data List Start
const defaultCaskAndAgingListData = {
  getCaskAndAgingListLoading: false,
  getCaskAndAgingListData: null,
  getCaskAndAgingListError: null,
};

const fetchCaskAndAgingList = createAsyncThunk(
  "caskandaging/caskAndAgingList",
  async (payload) => {
    return await CaskAndAgingService.getCaskAndAgingList(payload);
  },
);

const getCaskAndAgingListReducer = createSlice({
  name: "getCaskAndAgingListData",
  initialState: defaultCaskAndAgingListData,
  extraReducers: (builder) => {
    builder.addCase(fetchCaskAndAgingList.pending, (state) => {
      state.getCaskAndAgingListLoading = true;
    });
    builder.addCase(fetchCaskAndAgingList.fulfilled, (state, action) => {
      state.getCaskAndAgingListLoading = false;
      state.getCaskAndAgingListData = action.payload;
      state.getCaskAndAgingListError = "";
    });
    builder.addCase(fetchCaskAndAgingList.rejected, (state, action) => {
      state.getCaskAndAgingListLoading = false;
      state.getCaskAndAgingListData = null;
      state.getCaskAndAgingListError = action.error.message;
    });
  },
});

export const GetCaskAndAgingListReducer = getCaskAndAgingListReducer.reducer;
export const FetchCaskAndAgingList = fetchCaskAndAgingList;
// Get CaskAndAging Data List End

// Get CaskAndAging By Id Start
const getCaskAndAgingByIdState = {
  getCaskAndAgingByIdLoading: false,
  getCaskAndAgingByIdData: null,
  getCaskAndAgingByIdError: null,
};

const getCaskAndAgingDataById = createAsyncThunk(
  "caskandaging/caskAndAgingById",
  async (caskAndAgingId) => {
    return await CaskAndAgingService.getCaskAndAgingById(caskAndAgingId);
  },
);

const getCaskAndAgingByIdReducer = createSlice({
  name: "getCaskAndAgingById",
  initialState: getCaskAndAgingByIdState,
  extraReducers: (builder) => {
    builder.addCase(getCaskAndAgingDataById.pending, (state) => {
      state.getCaskAndAgingByIdLoading = true;
    });
    builder.addCase(getCaskAndAgingDataById.fulfilled, (state, action) => {
      state.getCaskAndAgingByIdLoading = false;
      state.getCaskAndAgingByIdData = action.payload;
      state.getCaskAndAgingByIdError = "";
    });
    builder.addCase(getCaskAndAgingDataById.rejected, (state, action) => {
      state.getCaskAndAgingByIdLoading = false;
      state.getCaskAndAgingByIdData = null;
      state.getCaskAndAgingByIdError = action.error.message;
    });
  },
});

export const GetCaskAndAgingByIdReducer = getCaskAndAgingByIdReducer.reducer;
export const GetCaskAndAgingDataById = getCaskAndAgingDataById;
// Get CaskAndAging By Id End

// Add Samplinglogs Start
const defaultSamplinglogsState = {
  addSamplinglogsLoading: false,
  addSamplinglogsData: null,
  addSamplinglogsError: null,
};

const addSamplinglogsData = createAsyncThunk(
  "samplinglogs/add",
  async (payload) => {
    return await CaskAndAgingService.createSamplinglogs(payload);
  },
);

const addSamplinglogsReducer = createSlice({
  name: "addSamplinglogsData",
  initialState: defaultSamplinglogsState,
  extraReducers: (builder) => {
    builder.addCase(addSamplinglogsData.pending, (state) => {
      state.addSamplinglogsLoading = true;
    });
    builder.addCase(addSamplinglogsData.fulfilled, (state, action) => {
      state.addSamplinglogsLoading = false;
      state.addSamplinglogsData = action.payload;
      state.addSamplinglogsError = "";
    });
    builder.addCase(addSamplinglogsData.rejected, (state, action) => {
      state.addSamplinglogsLoading = false;
      state.addSamplinglogsData = null;
      state.addSamplinglogsError = action.error.message;
    });
  },
});

export const AddSamplinglogsReducer = addSamplinglogsReducer.reducer;
export const AddSamplinglogsData = addSamplinglogsData;
// Add Samplinglogs End

// Update Samplinglogs Start
const updateSamplinglogsState = {
  updateSamplinglogsLoading: false,
  updateSamplinglogsData: null,
  updateSamplinglogsError: null,
};

const updateSamplinglogs = createAsyncThunk(
  "samplinglogs/update",
  async (payload) => {
    return await CaskAndAgingService.updateSamplinglogs(payload);
  },
);

const updateSamplinglogsReducer = createSlice({
  name: "updateSamplinglogsReducer",
  initialState: updateSamplinglogsState,
  extraReducers: (builder) => {
    builder.addCase(updateSamplinglogs.pending, (state) => {
      state.updateSamplinglogsLoading = true;
    });
    builder.addCase(updateSamplinglogs.fulfilled, (state, action) => {
      state.updateSamplinglogsLoading = false;
      state.updateSamplinglogsData = action.payload;
      state.updateSamplinglogsError = "";
    });
    builder.addCase(updateSamplinglogs.rejected, (state, action) => {
      state.updateSamplinglogsLoading = false;
      state.updateSamplinglogsData = null;
      state.updateSamplinglogsError = action.error.message;
    });
  },
});

export const UpdateSamplinglogsReducer = updateSamplinglogsReducer.reducer;
export const UpdateSamplinglogs = updateSamplinglogs;
//Update Samplinglogs End

// Get Samplinglogs Data List Start
const defaultSampingLogsListData = {
  getSamplingLogsListLoading: false,
  getSamplingLogsListData: null,
  getSamplingLogsListError: null,
};

const fetchSampingLogsList = createAsyncThunk(
  "sampinglogs/sampingLogsList",
  async (payload) => {
    return await CaskAndAgingService.getSamplinglogsList(payload);
  },
);

const getSampingLogsListReducer = createSlice({
  name: "getSampingLogsListData",
  initialState: defaultSampingLogsListData,
  extraReducers: (builder) => {
    builder.addCase(fetchSampingLogsList.pending, (state) => {
      state.getSamplingLogsListLoading = true;
    });
    builder.addCase(fetchSampingLogsList.fulfilled, (state, action) => {
      state.getSamplingLogsListLoading = false;
      state.getSamplingLogsListData = action.payload;
      state.getSamplingLogsListError = "";
    });
    builder.addCase(fetchSampingLogsList.rejected, (state, action) => {
      state.getSamplingLogsListLoading = false;
      state.getSamplingLogsListData = null;
      state.getSamplingLogsListError = action.error.message;
    });
  },
});

export const GetSampingLogsListReducer = getSampingLogsListReducer.reducer;
export const FetchSampingLogsList = fetchSampingLogsList;
// Get Samplinglogs Data List End

// Add Cask Open Logs Start
const defaultAddCaskOpenLogsState = {
  addCaskOpenLogsLoading: false,
  addCaskOpenLogsData: null,
  addCaskOpenLogsError: null,
};

const addCaskOpenLogsData = createAsyncThunk(
  "caskopenlogs/add",
  async (payload) => {
    return await CaskAndAgingService.createCaskOpenLogs(payload);
  },
);

const addCaskOpenLogsReducer = createSlice({
  name: "addCaskOpenLogsData",
  initialState: defaultAddCaskOpenLogsState,
  extraReducers: (builder) => {
    builder.addCase(addCaskOpenLogsData.pending, (state) => {
      state.addCaskOpenLogsLoading = true;
    });
    builder.addCase(addCaskOpenLogsData.fulfilled, (state, action) => {
      state.addCaskOpenLogsLoading = false;
      state.addCaskOpenLogsData = action.payload;
      state.addCaskOpenLogsError = "";
    });
    builder.addCase(addCaskOpenLogsData.rejected, (state, action) => {
      state.addCaskOpenLogsLoading = false;
      state.addCaskOpenLogsData = null;
      state.addCaskOpenLogsError = action.error.message;
    });
  },
});

export const AddCaskOpenLogsReducer = addCaskOpenLogsReducer.reducer;
export const AddCaskOpenLogsData = addCaskOpenLogsData;
// Add Cask Open Logs End

// Update Cask Open Logs Start
const defaultUpdateCaskOpenLogsState = {
  updateCaskOpenLogsLoading: false,
  updateCaskOpenLogsData: null,
  updateCaskOpenLogsError: null,
};

const updateCaskOpenLogs = createAsyncThunk(
  "caskopenlogs/update",
  async (payload) => {
    return await CaskAndAgingService.updateCaskOpenLogs(payload);
  },
);

const updateCaskOpenLogsReducer = createSlice({
  name: "updateCaskOpenLogsReducer",
  initialState: defaultUpdateCaskOpenLogsState,
  extraReducers: (builder) => {
    builder.addCase(updateCaskOpenLogs.pending, (state) => {
      state.updateCaskOpenLogsLoading = true;
    });
    builder.addCase(updateCaskOpenLogs.fulfilled, (state, action) => {
      state.updateCaskOpenLogsLoading = false;
      state.updateCaskOpenLogsData = action.payload;
      state.updateCaskOpenLogsError = "";
    });
    builder.addCase(updateCaskOpenLogs.rejected, (state, action) => {
      state.updateCaskOpenLogsLoading = false;
      state.updateCaskOpenLogsData = null;
      state.updateCaskOpenLogsError = action.error.message;
    });
  },
});

export const UpdateCaskOpenLogsReducer = updateCaskOpenLogsReducer.reducer;
export const UpdateCaskOpenLogs = updateCaskOpenLogs;
// Update Cask Open Logs End

// Get Cask Open Logs List Start
const defaultGetCaskOpenLogsListState = {
  getCaskOpenLogsListLoading: false,
  getCaskOpenLogsListData: null,
  getCaskOpenLogsListError: null,
};

const fetchCaskOpenLogsList = createAsyncThunk(
  "caskopenlogs/list",
  async (payload) => {
    return await CaskAndAgingService.getCaskOpenLogsList(payload);
  },
);

const getCaskOpenLogsListReducer = createSlice({
  name: "getCaskOpenLogsListData",
  initialState: defaultGetCaskOpenLogsListState,
  extraReducers: (builder) => {
    builder.addCase(fetchCaskOpenLogsList.pending, (state) => {
      state.getCaskOpenLogsListLoading = true;
    });
    builder.addCase(fetchCaskOpenLogsList.fulfilled, (state, action) => {
      state.getCaskOpenLogsListLoading = false;
      state.getCaskOpenLogsListData = action.payload;
      state.getCaskOpenLogsListError = "";
    });
    builder.addCase(fetchCaskOpenLogsList.rejected, (state, action) => {
      state.getCaskOpenLogsListLoading = false;
      state.getCaskOpenLogsListData = null;
      state.getCaskOpenLogsListError = action.error.message;
    });
  },
});

export const GetCaskOpenLogsListReducer = getCaskOpenLogsListReducer.reducer;
export const FetchCaskOpenLogsList = fetchCaskOpenLogsList;
// Get Cask Open Logs List End

// Get Cask Open Logs By Id Start
const defaultGetCaskOpenLogsByIdState = {
  getCaskOpenLogsByIdLoading: false,
  getCaskOpenLogsByIdData: null,
  getCaskOpenLogsByIdError: null,
};

const getCaskOpenLogsById = createAsyncThunk(
  "caskopenlogs/getById",
  async (caskOpenLogId) => {
    return await CaskAndAgingService.getCaskOpenLogsById(caskOpenLogId);
  },
);

const getCaskOpenLogsByIdReducer = createSlice({
  name: "getCaskOpenLogsByIdData",
  initialState: defaultGetCaskOpenLogsByIdState,
  extraReducers: (builder) => {
    builder.addCase(getCaskOpenLogsById.pending, (state) => {
      state.getCaskOpenLogsByIdLoading = true;
    });
    builder.addCase(getCaskOpenLogsById.fulfilled, (state, action) => {
      state.getCaskOpenLogsByIdLoading = false;
      state.getCaskOpenLogsByIdData = action.payload;
      state.getCaskOpenLogsByIdError = "";
    });
    builder.addCase(getCaskOpenLogsById.rejected, (state, action) => {
      state.getCaskOpenLogsByIdLoading = false;
      state.getCaskOpenLogsByIdData = null;
      state.getCaskOpenLogsByIdError = action.error.message;
    });
  },
});

export const GetCaskOpenLogsByIdReducer = getCaskOpenLogsByIdReducer.reducer;
export const GetCaskOpenLogsById = getCaskOpenLogsById;
// Get Cask Open Logs By Id End

// Delete Cask Open Logs Start
const defaultDeleteCaskOpenLogsState = {
  deleteCaskOpenLogsLoading: false,
  deleteCaskOpenLogsData: null,
  deleteCaskOpenLogsError: null,
};

const deleteCaskOpenLogs = createAsyncThunk(
  "caskopenlogs/delete",
  async (caskOpenLogId) => {
    return await CaskAndAgingService.deleteCaskOpenLogs(caskOpenLogId);
  },
);

const deleteCaskOpenLogsReducer = createSlice({
  name: "deleteCaskOpenLogsData",
  initialState: defaultDeleteCaskOpenLogsState,
  extraReducers: (builder) => {
    builder.addCase(deleteCaskOpenLogs.pending, (state) => {
      state.deleteCaskOpenLogsLoading = true;
    });
    builder.addCase(deleteCaskOpenLogs.fulfilled, (state, action) => {
      state.deleteCaskOpenLogsLoading = false;
      state.deleteCaskOpenLogsData = action.payload;
      state.deleteCaskOpenLogsError = "";
    });
    builder.addCase(deleteCaskOpenLogs.rejected, (state, action) => {
      state.deleteCaskOpenLogsLoading = false;
      state.deleteCaskOpenLogsData = null;
      state.deleteCaskOpenLogsError = action.error.message;
    });
  },
});

export const DeleteCaskOpenLogsReducer = deleteCaskOpenLogsReducer.reducer;
export const DeleteCaskOpenLogs = deleteCaskOpenLogs;
// Delete Cask Open Logs End

